import { formValueSelector } from 'redux-form'
import { TIRE_QUANTITY_FORM_NAME } from 'constant'

export const formSelector = formValueSelector(TIRE_QUANTITY_FORM_NAME)
